<template>
    <v-layout>
     <v-flex xs11>
        <p v-if="question.description && !edit" class="ml-2">{{question.description}}</p>  
        <div v-if="edit">
                   <v-textarea
                      v-if="edit"
                      v-model="question.description"
                      auto-grow
                      hide-details
                      :autofocus="true"
                      placeholder="Toelichting..."
                      class="minimal transparent"
                      :rows=2
                    ></v-textarea>
                     <v-layout>
                        <v-flex xs3>
                        <v-radio-group v-model="question.type" row>
                          <v-radio
                            label="Tekst"
                            color="blue"
                            value="textarea"
                          ></v-radio>
                          <v-radio
                            label="Keuzelijst"
                            color="red"
                            value="check"
                          ></v-radio>
                        </v-radio-group>
                        </v-flex>
                         <v-flex xs7>
                        <v-combobox
                            v-if="question.type=='check'"
                            v-model="question.options"
                            label="Opties"
                            chips
                            clearable
                            solo
                            flat
                            multiple
                            mt-2
                          >
                            <template v-slot:selection="data">
                              <v-chip
                                :selected="data.selected"
                                close
                              >
                                <strong>{{ data.item }}</strong>
                              </v-chip>
                            </template>
                          </v-combobox>
                          </v-flex>
                         </v-layout>
                </div>
               <div v-else>
                         <v-textarea
                      v-if="!readonly && question.type=='textarea'"
                      v-model="question.value"
                      label="Antwoord"
                      auto-grow
                      rows= 10
                      solo
                      flat
                      :autofocus="active"
                      
                      @blur="setScore(question)"
                      @keydown.tab="setActive()"
                      ref="input"
                    ></v-textarea>
                    <div>
                    <v-checkbox
                      v-if="!readonly && question.type=='check'"
                       v-for="(check,ii) in question.options"
                        :key="ii"
                      v-model="checks[check]"
                      :label="check"
                      :color="check"
                      hide-details
                      @click="setScore(question)"
                       :ref="`input${index}`"
                       class="mt-0 ml-2 pt-3"
                    ></v-checkbox>
                    </div>
                <div v-if="!readonly" class="text-lg-right">
                    score <v-btn-toggle v-model="question.score" class="transparent elevation-0" flat>
              <v-btn flat>
                <span>0</span>
              </v-btn>          
              <v-btn  flat v-for="n in max" :key="n">
                <span>{{n}}</span>
              </v-btn>
           </v-btn-toggle></div>
               
                </div>
                <div v-else><br></div>
        </v-flex>        
     <v-flex xs1 class="ml-5">           
           <v-text-field v-if="edit" label="Weight"  v-model="question.weight"></v-text-field>
           <span v-else>Weight: <b>{{question.weight}}</b></span>
    </v-flex>
   </v-layout>
</template>

<script>

export default {
    name: 'questionaire-question',
    props: ['question', 'edit', 'index', 'active', 'readonly', 'max'],
     data: () => ({
      
    }),
    computed: {
      checks() {
         if (!this.question.value) this.question.value = {}
         return this.question.value
      }
    },
    watch: {
        active (value){
         if (value == true){
          var self = this
          this.$nextTick(() => {
                setTimeout(() => {
                if (self.$refs['input']) self.$refs['input'].focus()
                },100)
          })
         }
        }
      },
    methods: {
        setScore (question) {
            this.$emit('setScore',question)
        },
        setActive () {
            this.$emit('setActive')
        }
    }
}
</script>
